window.notificationAppSettings = function () {
  return {
    loading: true,
    permission: {
      enabled: false,
      status: 'unknown',
      canAskAgain: false,
    },

    get showCard () {
      return window.isNative || this.permission.status !== 'unsupported'
    },

    get statusLabel () {
      if (this.loading) {
        return 'Laden...'
      }

      if (this.permission.status === 'unsupported') {
        return 'Niet ondersteund'
      }

      return this.permission.enabled ? 'Ingeschakeld' : 'Uitgeschakeld'
    },

    get statusBadgeClass () {
      if (this.permission.status === 'unsupported') {
        return 'bg-gray-100 text-gray-600'
      }

      if (this.permission.enabled) {
        return 'bg-green-100 text-green-700'
      }

      return 'bg-red-100 text-red-700'
    },

    get showEnableButton () {
      return !this.loading && this.permission.status !== 'unsupported' && !this.permission.enabled
    },

    get showManualInstructions () {
      return this.showEnableButton && this.permission.canAskAgain === false
    },

    async init () {
      await this.refreshPermission()
    },

    async refreshPermission () {
      this.loading = true

      try {
        if (window.pushRegistration?.getNotificationPermissionStatus) {
          this.permission = await window.pushRegistration.getNotificationPermissionStatus()
        } else {
          this.permission = {
            enabled: false,
            status: 'unsupported',
            canAskAgain: false,
          }
        }
      } catch (error) {
        console.debug('notification settings: failed to load push permission', error)
      }

      this.loading = false
    },

    async enableNotifications () {
      this.loading = true

      try {
        if (window.pushRegistration?.enableNotificationsAndRegisterToken) {
          const permission = await window.pushRegistration.enableNotificationsAndRegisterToken({
            openSettingsIfDenied: true,
            force: true,
          })

          if (permission) {
            this.permission = permission
          }
        }
      } catch (error) {
        console.debug('notification settings: failed to enable push notifications', error)
      }

      await this.refreshPermission()
    },
  }
}
